import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, LabelList } from 'recharts';
import { LiaBasketballBallSolid, LiaBookSolid, LiaSchoolSolid, LiaUserGraduateSolid } from "react-icons/lia";
import { useState } from 'react';
import ReportDescriptionModal from './ReportDescriptionModal';

const ProgressChart = ({report}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const getSegmentLabel = (segmentKey) => {
    switch (segmentKey) {
      case 'preschool':
        return 'Infantil';
      case 'elementary-I':
        return 'Fund I';
      case 'elementary-II':
        return 'Fund II';
      case 'high-school':
        return 'Médio';
      default:
        return segmentKey;
    }
  }

  const getColorForSegment = (segmentKey) => {
    switch (segmentKey) {
      case 'preschool':
        return '#8B5CF6';
      case 'elementary-I':
        return '#3B82F6';
      case 'elementary-II':
        return '#10B981';
      case 'high-school':
        return '#F59E0B';
      default:
        return '#6B7280';
    }
  }

  const parseProgress = (progressString) => {
    const [completed, total] = progressString.split(' de ').map(num => parseInt(num));
    const percentage = total > 0 ? ((completed / total) * 100).toFixed(1) : 0;
    return { completed, total, percentage: parseFloat(percentage) };
  }

  const data = report?.lines?.map(line => {
    const progress = parseProgress(line.value);
    return {
      name: getSegmentLabel(line.key),
      originalValue: line.value,
      completed: progress.completed,
      total: progress.total,
      percentage: progress.percentage,
      color: getColorForSegment(line.key)
    };
  }) || [];

  return (
    <>
      <div className='flex items-center gap-2 mb-4'>
        <LiaBookSolid className="text-xl text-green-600" />
        <h3 className='text-lg font-semibold text-gray-900'>{report?.title || 'Progresso de Rematrículas'}</h3>
        {report?.description && (
          <button
            onClick={() => setIsModalOpen(true)}
            className="w-4 h-4 bg-gray-400 rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-500 transition-colors duration-200"
          >
            <span className="text-white text-xs font-bold">?</span>
          </button>
        )}
      </div>
      
      <div className="flex flex-col items-center">
        <div className="h-72 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <XAxis 
                dataKey="name" 
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 12, fill: '#6B7280' }}
              />
              <YAxis 
                axisLine={false}
                tickLine={false}
                hide={true}
              />
              <Bar dataKey="percentage" radius={[4, 4, 0, 0]}>
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
                <LabelList 
                  dataKey="originalValue" 
                  position="center" 
                  fill="white" 
                  fontSize={12} 
                  fontWeight="bold"
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
        
        {/* Chart Labels at Bottom */}
        <div className="flex justify-center gap-6 mt-4">
          {data.map((item, index) => (
            <div key={index} className="flex items-center gap-2">
              <div 
                className="w-3 h-3 rounded-full flex-shrink-0" 
                style={{ backgroundColor: item.color }}
              ></div>
              <div className="text-center">
                <p className="text-xs font-medium text-gray-600">{item.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <ReportDescriptionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={report?.title || 'Progresso de Rematrículas'}
        description={report?.description}
      />
    </>
  );
};

export default ProgressChart;
